import { formatToCOP } from "./templateProduct";
import { iconAddToCart, iconDelete, viewVariants } from "../icons";
export const templateWishlist = (product) => {
  const isAvailable = product.available
    ? product.available
    : Array.isArray(product.variants) &&
      product.variants.some((variant) => variant.available);
  if (!isAvailable) {
    return "";
  }
  const price = product.price
    ? Number(product.price) / 100
    : Number(product.variants[0]?.price) / 100 || 0;

  const comparePrice = product.variants[0]?.compare_at_price
    ? Number(product.variants[0]?.compare_at_price) / 100
    : null;

  let variantsLength = product.variants.length;
  return `
    <article class="article-wishlist">
        <a href="/products/${product.handle}">
            <figure class="article-wishlist__figure">
             <img src="${product.featured_image}" alt="${product.title}">
            </figure>
        </a>
        <div class="article-wishlist__info">
            <a href="/products/${product.handle}">
                <h3 class="article-wishlist__title">${product.title}</h3>
            </a>
            <div class="article-wishlist__price">
                <span class="article-wishlist__span article-wishlist__span--price">
                 ${formatToCOP(price)}
                </span>
                ${
                  comparePrice
                    ? `<span class="article-wishlist__span article-wishlist__span--compare-price">
                ${formatToCOP(comparePrice)}
                </span>`
                    : ""
                }
            </div>
            <div class="article-wishlist__handlers">
                ${
                  variantsLength > 1
                    ? `<a href="/products/${product.handle}" class="article-wishlist__add-to-cart product-article__handlers--open-variants">
                <i>${viewVariants}</i>
                </a>`
                    : `<button class="article-wishlist__add-to-cart add-to-cart" 
                data-product-id="${product.variants[0]?.id}">
                <i>${iconAddToCart}</i>
                <div class="product-article__action--loader">
                    <div class="circle"></div>
                    <div class="circle"></div>
                    <div class="circle"></div>
                    <div class="circle"></div>
                </div>
                </button>`
                }
            </div>
        </div>
    <button class="article-wishlist__delete" data-product-handle=${
      product.handle
    }>${iconDelete}</button>
    </article>
    `;
};
